import React, { useEffect, useState } from 'react'
// import HeaderBanner from '../ui/HeaderBanner'
import client from '../../client/Client'

interface VenueInfo {
  venueName?: string
  venueAddress?: string
  venueGoogleMapsLink?: string
}

const ContactUs = () => {
  const [venueInfo, setVenueInfo] = useState<VenueInfo | null>(null)

  useEffect(() => {
    client
      .fetch(
        `*[_type == "WelcomeParagh"][0]{
          venueName,
          venueAddress,
          venueGoogleMapsLink
        }`
      )
      .then((result) => {
        setVenueInfo(result)
      })
      .catch((error) => {
        console.error('Error fetching venue data:', error)
      })
  }, [])

  const venueName = venueInfo?.venueName
  const venueAddress = venueInfo?.venueAddress
  const googleMapsLink = venueInfo?.venueGoogleMapsLink || ''

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-32 pb-24">
      <div
        className="fixed left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none -z-1"
        aria-hidden="true"
      >
        <svg
          width="1360"
          height="578"
          viewBox="0 0 1360 578"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient
              x1="50%"
              y1="0%"
              x2="50%"
              y2="100%"
              id="illustration-01"
            >
              <stop stopColor="#FFF" offset="0%" />
              <stop stopColor="#EAEAEA" offset="77.402%" />
              <stop stopColor="#DFDFDF" offset="100%" />
            </linearGradient>
          </defs>
          <g fill="url(#illustration-01)" fillRule="evenodd">
            <circle cx="1232" cy="128" r="128" />
            <circle cx="155" cy="443" r="64" />
          </g>
        </svg>
      </div>

      {/*
        To restore the old HeaderBanner later:
        1. Uncomment the import at the top:
           import HeaderBanner from '../ui/HeaderBanner'
        2. Uncomment the line below.
      */}
      {/* <HeaderBanner title="Contact Us" /> */}

      <section className="pt-8">
        <div className="rounded-2xl border border-gray-100 bg-white shadow-sm overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-3">
            <div className="lg:col-span-1 bg-gray-50 p-6 sm:p-8 border-b lg:border-b-0 lg:border-r border-gray-100">
              <span className="inline-flex items-center rounded-full bg-red-50 border border-red-100 px-4 py-2 text-sm font-bold text-red-500">
                SSD Contact
              </span>

              <h1 className="mt-5 text-3xl sm:text-4xl font-extrabold text-[#00094f]">
                Get in touch
              </h1>

              <p className="mt-4 text-gray-600 leading-7">
                For questions about SSD, conference participation, submissions,
                or general information, please contact the organizing team.
              </p>

              <div className="mt-6 h-1 w-20 rounded-full bg-red-500" />
            </div>

            <div className="lg:col-span-2 p-6 sm:p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="group rounded-2xl border border-gray-100 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-red-100 hover:shadow-md">
                  <div className="flex items-center gap-4">
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-red-50 text-red-500">
                      <svg
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 21s7-4.438 7-11a7 7 0 10-14 0c0 6.562 7 11 7 11z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 10.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                        />
                      </svg>
                    </div>

                    <div>
                      <p className="text-sm font-bold uppercase tracking-wide text-gray-500">
                        Location
                      </p>
                      <h2 className="text-xl font-bold text-red-500">
                        Conference Venue
                      </h2>
                    </div>
                  </div>

                  <div className="mt-5">
                    {venueName ? (
                      <h3 className="text-lg font-extrabold text-[#00094f]">
                        {venueName}
                      </h3>
                    ) : (
                      <h3 className="text-lg font-extrabold text-[#00094f]">
                        Venue will be announced soon.
                      </h3>
                    )}

                    {venueAddress && (
                      <p className="mt-3 text-base leading-7 text-gray-700">
                        {venueAddress}
                      </p>
                    )}

                    {googleMapsLink && (
                      <a
                        href={googleMapsLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-5 inline-flex items-center justify-center rounded-lg bg-red-800 px-4 py-2 text-sm font-bold text-white transition duration-200 hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-2"
                      >
                        Open in Google Maps
                        <svg
                          className="ml-2 h-4 w-4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M17 8l4 4m0 0l-4 4m4-4H3"
                          />
                        </svg>
                      </a>
                    )}
                  </div>
                </div>

                <div className="group rounded-2xl border border-gray-100 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-red-100 hover:shadow-md">
                  <div className="flex items-center gap-4">
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#00094f]/5 text-[#00094f]">
                      <svg
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3 8l9 6 9-6"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 6h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2z"
                        />
                      </svg>
                    </div>

                    <div>
                      <p className="text-sm font-bold uppercase tracking-wide text-gray-500">
                        Email
                      </p>
                      <h2 className="text-xl font-bold text-red-500">
                        Contact Address
                      </h2>
                    </div>
                  </div>

                  <a
                    href="mailto:info@ssd-multiconf.org"
                    className="mt-5 inline-flex items-center gap-2 text-base font-bold text-[#00094f] transition-colors duration-200 hover:text-red-500"
                  >
                    info@ssd-multiconf.org

                    <svg
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M17 8l4 4m0 0l-4 4m4-4H3"
                      />
                    </svg>
                  </a>

                  <p className="mt-4 text-sm leading-6 text-gray-500">
                    Send us an email and the SSD organizing team will get back to you.
                  </p>
                </div>
              </div>

              <div className="mt-8 rounded-2xl border border-gray-100 bg-gray-50 p-5 sm:p-6">
                <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                  <div>
                    <p className="text-sm font-bold uppercase tracking-wide text-[#00094f]">
                      Need assistance?
                    </p>
                    <p className="mt-1 text-gray-600">
                      Please include your name, affiliation, and the topic of your request.
                    </p>
                  </div>

                  <a
                    href="mailto:info@ssd-multiconf.org"
                    className="inline-flex items-center justify-center rounded-lg bg-red-800 px-5 py-3 text-sm font-bold text-white transition duration-200 hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-2"
                  >
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ContactUs